import React from 'react';
import { withAuthenticator } from '@aws-amplify/ui-react';
import clsx from 'clsx';
import styles from './styles.module.scss';

const RadiologyInsights = () => {
  return (
    <div className={clsx(styles['placeholder-wrapper'])}>
      <h2 className={styles['placeholder-title']}>Currently unavailable in your account, please enquire for more details.</h2>
    </div>
  );
};

export default withAuthenticator(RadiologyInsights, {
  hideSignUp: true,
});
